
import { Component, Prop, Vue, Watch, Ref, Mixins, PropSync } from "vue-property-decorator";
import { Form } from "element-ui/types";
import UploadImg from "@/components/uploadImg.vue";
import TablePagination from "@/mixins/tablePagination";
import { saveOrUpdateMessage } from "@/api/publicNumberMessage";
import dayjs from "dayjs";

@Component({
    components: { UploadImg }
})
export default class EditDialog extends Mixins(Vue, TablePagination) {
    @Ref("validateForm") formRef: Form;
    @PropSync("formData") private formDataSync!: any;
    @Prop([String]) private dialogTitle!: string;
    @Prop([Boolean]) private dialogVisible!: boolean;

    formRules = {
        wxMessageTitle: [{ required: true, message: "请输入消息标题", trigger: "blur" }],
        wxMessageContent: [{ required: true, message: "请输入消息内容", trigger: "blur" }],
        pushTime: [{ required: true, message: "请选择推送时间", trigger: "change" }],
        receiveBy: [{ required: true, message: "请选择接收人", trigger: "change" }],
        status: [{ required: true, message: "请选择状态", trigger: "change" }],
    };

    saveLoading = false;

    mounted() {
    }

    dialogClose() {
        this.$emit('closeEditDialog');
        this.formRef?.resetFields();
        this.saveLoading = false;
    }

    saveSymptomsInfo() {
        this.formRef?.validate((valid) => {
            if (valid) {
                const _pushTime = dayjs(this.formDataSync.pushTime).format("YYYY-MM-DD HH:mm:ss");
                const _status = Number(this.formDataSync.status);
                const _imgUrl = this.formDataSync.imgUrl[0]?.url;
                this.saveLoading = true;
                saveOrUpdateMessage({ ...this.formDataSync, pushTime: _pushTime, status: _status, imgUrl: _imgUrl || "" }).then((res) => {
                    this.$message.success("保存成功");
                    this.$emit('editDialogConfirm');
                    this.dialogClose();
                }).finally(() => {
                    this.saveLoading = false;
                })
            } else {
                return false;
            }
        })
    }

    handleDateTimeChange(value: Date | null) {
        if (value) {
            const date = new Date(value);
            date.setMinutes(0, 0, 0); // 设置分钟和秒为 00
            this.formDataSync.pushTime = date;
        }
    }
}
